export default (number, presicion = 3) => Math.round(number * (Math.pow(10, presicion))) / Math.pow(10, presicion);
